module.exports = __webpack_public_path__ + "img/CEO-Achmad-Masfuri.793bdc5e.jpg";